
<div class="container-fluid">
    <div class="row">
        <div class="col-12">

            <table class="table table-striped mt-3">
                <thead class="text-primary">
                    <tr>
                        <th>Name</th>
                        <th>Importer</th>
                        <th>Shipper/Seller</th>
                        <th>Warehouse</th>
                        <th>ISF</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let t of templates;">
                        <td>{{t.name}}</td>
                        <td>{{t?.importer?.name}}</td>
                        <td>{{t?.manufacturer?.name}}</td>
                        <td>{{t?.warehouse?.name}}</td>
                        <td>
                            <button class="btn btn-primary" (click)="isf(t)">New</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
